import React, { useEffect } from "react";
import StandardTemplate from "../../../templates/standard_template/standard_template";
import FullRealtorList from "../../../components/loan_tools/forms/full_realtor_list";
import { useDocument } from "../../../components/loan_tools/loan_tool";

export default function FullRealtorListRoute() {
  const [loanDoc, , , actions] = useDocument();

  useEffect(() => {
    const borrowers = loanDoc && loanDoc.applicant && loanDoc.applicant.borrowers;
    const lastName = (borrowers && borrowers[0] && borrowers[0].last_name) || "";
    const title = lastName
      ? `${lastName} – Full Realtor List`
      : "Full Realtor List";
    actions.setPageTitleOverride(title);
    return () => actions.setPageTitleOverride(null);
  }, [loanDoc]);

  return (
    <StandardTemplate className="ba-template">
      <FullRealtorList />
    </StandardTemplate>
  );
}
